import styled from 'styled-components'

export const PatientAccessFormItem = styled.div({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center'
})
